module.exports = __webpack_public_path__ + "static/works-two-d2244c2f8843f9c594e24ea7b8dcce17.svg";